<!--
 * @Description: 交稿弹框
 * @Author: black-k
 * @Date: 2025-09-11 13:03:06
 * @LastEditors: black-k
 * @LastEditTime: 2025-09-12 09:36:53
-->
<template>
    <div class="basic-dialog task-dialog manuscript-dialog">
        <el-dialog
            :title="title"
            :visible="visible"
            @update:visible="handleUpdateVisible"
            width="720px"
            :close-on-click-modal="false"
            :destroy-on-close="true"
        >
            <el-scrollbar class="dialog-scrollbar">
                <slot name="tip"></slot>

                <ActionForm
                    ref="actionFormRef"
                    :desc="{
                        label: '交稿说明',
                        placeholder: '请填写你匹配该任务的能力、优势等，也可提交附件证明',
                    }"
                >
                    <template slot="custom" slot-scope="scope">
                        <el-checkbox class="privacy-check" v-model="is_privacy">稿件隐藏：保护您的作品隐私</el-checkbox>
                    </template>
                </ActionForm>
            </el-scrollbar>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="handleUpdateVisible(false)">取 消</el-button>
                <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { request } from "../../util";
import { isEmpty } from "@/utils/common";
import ActionForm from "./ActionForm.vue";
import taskApi from "@/apis/task";
import { v4 } from "uuid";

export default {
    data() {
        return {
            is_privacy: false,
            request: request(),
        };
    },

    props: {
        visible: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            default: "交稿信息",
        },

        taskId: {
            type: Number,
        },

        budget: {
            type: Number,
            default: 0,
        },
    },

    components: {
        ActionForm,
    },

    watch: {
        visible(val) {
            if (val) {
                this.getManuscriptDetail();
            }
        },
    },

    methods: {
        reset() {
            this.$refs.actionFormRef?.reset?.();
        },

        handleUpdateVisible(val) {
            this.$emit("update:visible", val);

            if (!val) {
                this.reset();
            }
        },

        handleConfirm() {
            this.$refs.actionFormRef?.validate((valid, data) => {
                if (valid) {
                    this.$emit("confirm", {
                        is_privacy: this.is_privacy ? 1 : 0, // 报名-统一设置隐私
                        price: this.budget,
                        description: data.description,
                        urls: data.urls.map((item) => ({ name: item.name, url: item.url })),
                        files: [...data.files],
                    });
                }
            });
        },

        getManuscriptDetail() {
            if (!this.taskId) return;

            const params = { task_id: this.taskId };

            this.request.axiosGetBy(taskApi.taskApplyInfo, params, (res) => {
                if (res.code === 200) {
                    if (isEmpty(res.data)) return;

                    const data = {
                        price: res.data?.price,
                        description: res.data?.description,
                        urls: res.data?.urls?.map((item) => ({ ...item, key: v4().replaceAll("-", "") })),
                        files: res.data?.files,
                    };

                    this.$refs.actionFormRef?.initData?.(data);
                    this.is_privacy = res.data?.is_privacy === 1;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.manuscript-dialog {
    .privacy-check {
        margin-bottom: 22px;

        ::v-deep .el-checkbox__label {
            padding-left: 4px;
        }

        ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
            color: #594fed;
        }

        ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
        ::v-deep .el-checkbox__inner:hover {
            border-color: #594fed;
        }

        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #594fed;
            border-color: #594fed;
        }
    }
}
</style>
